/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const ContractRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_DATA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/policyholder-data/policyholder-data.module').then(m => m.PolicyholderDataPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_DETAILS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/policyholder-details/policyholder-details.module').then(
        m => m.PolicyholderDetailsPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.FAMILY_DEPENDENTS_DATA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/family-dependents-data/family-dependents-data.module').then(
        m => m.FamilyDependentsDataPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.VEHICLE_OWNER_DETAILS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/vehicle-owner-details/vehicle-owner-details.module').then(
        m => m.VehicleOwnerDetailsPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.INSURANCE_HISTORY.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/insurance-history/insurance-history.module').then(m => m.InsuranceHistoryPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.VEHICLE_SPECIFICATIONS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/vehicle-specifications/vehicle-specifications.module').then(
        m => m.VehicleSpecificationsPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.BANK_ACCOUNT_HOLDER_DETAILS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/bank-account-holder-details/bank-account-holder-details.module').then(
        m => m.BankAccountHolderDetailsPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.PREVIOUS_PH.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/contract/previous-ph/previous-ph.module').then(m => m.PreviousPHPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.IBAN_DATA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/contract/iban-data/iban-data.module').then(m => m.IbanDataPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.SEPA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/contract/sepa/sepa.module').then(m => m.SepaPageModule),
    canActivate: [NavigationGuard],
  },
];
